import React from 'react'

import cn from 'classnames'

import styles from './IconWrapper.module.scss'
import type { IconWrapperProps } from '../types'

const IconWrapper: React.FC<IconWrapperProps> = ({
  children,
  className,
  size = 'medium',
  shouldFlipRTL = false,
  ...props
}) => {
  if (!children) return null

  const viewBox = size === 'small' ? '0 0 16 16' : '0 0 24 24'
  const iconSize = size === 'small' ? '16' : '24'
  const classString = cn(className, shouldFlipRTL && styles.shouldFlipRTL)

  return (
    <svg
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      height={iconSize}
      width={iconSize}
      {...(classString && { className: classString })}
      {...props}
    >
      {children}
    </svg>
  )
}

export default IconWrapper
